import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, InputNumber, Switch, TimePicker } from 'antd'
import dayjs from 'dayjs'
import { SelectF } from '@/i2antdV5'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { parseHmStringToDayMinutes } from '@/utils/renderUtils'

const FormItem = Form.Item

function minutesToClock (raw) {
  if (raw == null || raw === '') return undefined
  if (Number(raw) === 1440) return dayjs().hour(0).minute(0).second(0)
  const minutes = parseHmStringToDayMinutes(raw)
  if (minutes == null) return undefined
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return dayjs().hour(h).minute(m).second(0)
}

class ShiftForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    getJStoreList: PropTypes.object,
    shiftList: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { dispatch, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    if (!Array.isArray(storeOptions) || storeOptions.length === 0) {
      dispatch(fetchJStoreList({ query: {}, dataType: 'optionTuina' }))
    }
    this.syncRecord()
  }

  componentDidUpdate (prevProps) {
    const prevId = prevProps.record && prevProps.record.id
    const nextId = this.props.record && this.props.record.id
    if (prevProps.actType !== this.props.actType || prevId !== nextId) {
      this.syncRecord()
      return
    }
    const prevList = prevProps.getJStoreList.data
    const nextList = this.props.getJStoreList.data
    const prevEmpty = !Array.isArray(prevList) || prevList.length === 0
    const nextHas = Array.isArray(nextList) && nextList.length > 0
    if (prevEmpty && nextHas) this.syncRecord()
  }

  syncRecord = () => {
    const { form, actType, record, shiftList, getJStoreList } = this.props
    if (!form || !form.current) return
    const storeOptions = getJStoreList.data
    const firstStore = Array.isArray(storeOptions) && storeOptions[0]
    const firstStoreId = firstStore && firstStore.id != null && firstStore.id !== ''
      ? String(firstStore.id)
      : undefined
    const values = {
      bookable: true,
      sortOrder: 0,
      storeId: firstStoreId
    }
    const queryStoreId = shiftList.query.storeId
    if (queryStoreId != null && queryStoreId !== '') {
      values.storeId = String(queryStoreId)
    }
    if (actType === 'edit' && record) {
      values.storeId = record.storeId == null || record.storeId === ''
        ? undefined
        : String(record.storeId)
      values.name = record.name
      values.startTime = minutesToClock(record.startTime)
      values.endTime = minutesToClock(record.endTime)
      values.restStartTime = minutesToClock(record.restStartTime)
      values.restEndTime = minutesToClock(record.restEndTime)
      values.bookable = record.bookable
      values.sortOrder = record.sortOrder
    }
    form.current.setFieldsValue(values)
  }

  render () {
    const { form, actType, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="门店"
          name="storeId"
          rules={[{ required: true, message: '请选择门店' }]}
        >
          <SelectF
            options={storeOptions}
            modalProps={{
              size: 'large',
              placeholder: '请选择门店',
              disabled: actType === 'edit'
            }}
          />
        </FormItem>
        <FormItem
          label="名称"
          name="name"
          rules={[{ required: true, message: '请填写名称' }]}
        >
          <Input size="large" placeholder="如 早班" maxLength={128} />
        </FormItem>
        <FormItem
          label="上班"
          name="startTime"
          rules={[{ required: true, message: '请选择上班时间' }]}
        >
          <TimePicker size="large" format="HH:mm" allowClear={false} style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="下班"
          name="endTime"
          rules={[{ required: true, message: '请选择下班时间' }]}
        >
          <TimePicker size="large" format="HH:mm" allowClear={false} style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="休息开始 (可空=无午休)"
          name="restStartTime"
        >
          <TimePicker size="large" format="HH:mm" style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="休息结束 (可空=无午休)"
          name="restEndTime"
        >
          <TimePicker size="large" format="HH:mm" style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="可约"
          name="bookable"
          valuePropName="checked"
        >
          <Switch />
        </FormItem>
        <FormItem
          label="排序"
          name="sortOrder"
          extra="数字越小越靠前。"
        >
          <InputNumber size="large" precision={0} style={{ width: '100%' }} />
        </FormItem>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  getJStoreList: state.components.getJStoreList,
  shiftList: state.tuina.shiftList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ShiftForm)
